export default {"src":"/_next/static/media/st.18feaffd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};